module.exports = __webpack_public_path__ + "img/auditoria.a3960898.png";